import { ChangeEvent, useState } from "react"
import CustomInput from "../../component/CustomInput/CustomInput"
import Button from "../../component/button/button"
import { login, requestPasswordReset } from "../../api/auth"
import { useNavigate } from "react-router-dom"
import { getProfile } from "../../api/profile"
import { IoArrowBack } from "react-icons/io5"

const InputEmail = () => {
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({
    email: "",
  })
  const navigate = useNavigate()

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }))
  }
  const validate = () => {
    let isValid = true
    const { email } = form
    if (!email) {
      isValid = false
    }

    return isValid
  }
  const handleReset = (e: any) => {
    if (loading) return
    e.preventDefault()
    const isValid = validate()

    if (!isValid) {
      return
    }

    setLoading(true)
    requestPasswordReset(form.email)
      .then((res) => {
        setLoading(false)
        navigate("/otp-password", { state: { email: form.email } })
      })
      .catch((err) => {
        console.log({ err })
        setLoading(false)
        setError("Failed to send reset instructions. Please try again.")
      })
  }

  return (
    <div className='content login'>
      <div className='login_container'>
        <h2 className='title'>Forgot Password?</h2>
        <p>No worries, we'll send you reset instructions.</p>

        <form onSubmit={handleReset}>
          <CustomInput
            placeholder='Please Enter your email'
            value={form.email}
            onChange={handleChange}
            name={"email"}
            error={error}
          />

          <Button
            text='Reset Password'
            style={{
              marginTop: 12,
            }}
            type='secondary'
            buttonType='submit'
            isLoading={loading}
            loadingText={"Sending..."}
          />
        </form>

        <p
          className='no_account cursor-pointer'
          onClick={() => navigate("/login")}
        >
          <IoArrowBack /> Back to log in
        </p>
      </div>
    </div>
  )
}

export default InputEmail
